
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#E4E8F8","d":"M14.825 19.508h-4.796v1.704h4.796l3.689 3.689v-2.53zM14.008 3.079c1.52.48 2.907 1.308 4.05 2.42a10.364 10.364 0 0 0-16.959 0 10.219 10.219 0 0 1 4.052-2.42 4.562 4.562 0 1 0 8.902.212c-.012-.07-.03-.14-.045-.212zm-4.43 2.227a1.19 1.19 0 0 1-1.19-1.174c.001-.074.01-.148.024-.22a1.19 1.19 0 0 1 2.34 0c.016.072.024.146.025.22a1.19 1.19 0 0 1-1.198 1.174z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M12.244 15.862h2.58v5.35H10.03v-3.134M18.514 24.9l-3.69-3.688v-5.35l3.69-3.69zM20.771 16.489a2.777 2.777 0 0 1 0 3.913M21.947 15.31a4.431 4.431 0 0 1 0 6.269M23.118 14.14a6.085 6.085 0 0 1 0 8.609M1.1 24.9L24.9 1.1M14.053 3.293c.053.276.08.557.08.839a4.562 4.562 0 0 1-9.109 0c0-.282.027-.563.08-.84"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M10.75 3.912a1.19 1.19 0 0 0-2.364.22 1.19 1.19 0 0 0 2.38 0 1.15 1.15 0 0 0-.015-.22z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5","d":"M18.058 5.499a10.372 10.372 0 0 0-16.959 0M1.1 5.499a10.314 10.314 0 0 0 8.479 4.397 10.314 10.314 0 0 0 8.479-4.397"}})])])
          )
        }
      }
    